import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setActivityTiming, setSelectedActivity } from "../../store/MahutiReducer";
import { ELEMENT_LINK, scrollToSection } from "../../utils/GlobalParams";
import { getHoursSF } from "../../utils/sfUtils";
import { onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import MahutiInputTimeList from "../mahuti-input-time/MahutiInputTimeList";

import './LandingPageStepThree.css'
function LandingPageStepThree() {
    const [errorMessageHead, setErrorMessageHead] = useState(undefined)

    const store = useSelector(state => state.reducer);
    const navigate = useNavigate()
    const location = useLocation()

    const [activityTimeSlots, setActivityTimeSlots] = useState([]);
    const [isLoadingTimeSlots, setIsLoadingTimeSlots] = useState(true);
    let finalMount = useRef(true);
    const dispatch = useDispatch();
    useEffect(() => {
        if (finalMount.current) {
            scrollToSection(ELEMENT_LINK["#sellingflow"])
            finalMount.current = false;
            const selectedActivityLocal = localStorage.getItem('step') ? JSON.parse(localStorage.getItem('step')) : undefined
            if (selectedActivityLocal && (!store.selectedActivity || !store.selectedActivity.Id)) {
                dispatch(setSelectedActivity(selectedActivityLocal));
            }
            getHoursSF(store)
                .then(res => { setActivityTimeSlots(res.data.records); setIsLoadingTimeSlots(false); })
                .catch((err) => { setErrorMessageHead(err.message); setIsLoadingTimeSlots(false) });
        }

        return () => {
            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => dispatch(setActivityTiming(undefined)));
        }
    }, [])
    return <div id="main-content" className="landingPageStepThree">
        {errorMessageHead && <div className="alert alert-text">{errorMessageHead}</div>}
        <div className="ps-lg-5 pe-lg-4 p-3 pt-lg-4 pb-lg-0">
            {isLoadingTimeSlots ? <div className="col"><div className="loader" /></div> :
                <MahutiInputTimeList activityTimeSlots={activityTimeSlots} />}
        </div>

    </div>
}

export default LandingPageStepThree;